import { tickerItems } from '../data';

export default function TopBar() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="bg-primary-900 text-background-50">
      <div className="mx-auto flex w-full max-w-7xl items-center gap-0 md:gap-3 overflow-hidden">
        <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-700 px-3 py-2 md:px-4">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-300 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-300" />
          </span>
          <span className="whitespace-nowrap font-label text-[11px] md:text-xs font-semibold tracking-wide">实时更新</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-ticker flex w-max items-center gap-8 px-6 py-2">
            {loop.map((item, i) => (
              <span key={i} className="whitespace-nowrap text-[11px] md:text-xs text-background-100/90">
                <i className="ri-arrow-right-s-line w-3 h-3 mr-1 inline-flex items-center justify-center align-middle" />
                {item}
              </span>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-primary-900 to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-primary-900 to-transparent" />
        </div>
      </div>
    </div>
  );
}